import { render } from "./BindEs.vue?vue&type=template&id=05525450&scoped=true"
import script from "./BindEs.vue?vue&type=script&lang=js"
export * from "./BindEs.vue?vue&type=script&lang=js"

import "./BindEs.vue?vue&type=style&index=0&id=05525450&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05525450"]])

export default __exports__